<script lang="ts">import MediaControls from '../MediaControls/MediaControls.svelte';
// prettier-ignore
const { class: className = '', ...rest } = $props();
</script>

<MediaControls {...rest} as="div" class="VideoPlayback {className}" isPlaying={false} useAriaLabel={true} />

<style>:global(.VideoPlayback) {
  --media-controls-height: var(--video-playback-height);
  --media-controls-width: var(--video-playback-width);
  --media-controls-icon-play-height: var(--video-playback-icon-height);
  --media-controls-icon-play-width: var(--video-playback-icon-width);
}</style>
